export const BUSINESS_CATEGORY_KEY = 'business_category_key';
export const SEGMENT_CATEGORY_KEY = 'segment_category_key';
export const ARENA_FILE_CATEGORY_KEY = 'arena_file_category_key';
export const ARENA_EVENT_CATEGORY_KEY = 'arena_event_category_key';
export const MEETING_EVENT_CATEGORY_KEY = 'meeting_event_category_key';
export const RETRACTABLE_OPTIONS_KEY = 'retractable_options_key';
export const STAGE_TYPE_KEY = 'stage_type_key';
export const AUDIENCE_TYPE_KEY = 'audience_type_key';

// footer
export const FOOTER_ADDRESS_KEY = 'footerAddressKey';
export const FOOTER_MENU_KEY = 'footerMenuKey';
export const FOOTER_CONTACT_KEY = 'footerContactKey';
export const FOOTER_SNS_KEY = 'footerSnsKey';
export const PRIVACY_POLICY_KEY = 'privacyPolicyKey';
export const TERMS_CONDITIONS_KEY = 'termsConditionsKey';
